import * as React from 'react'

import { AddonDetailStateProvider } from '../contexts/AddonDetailStateProvider'
import { AddonDetailResponsiveContent } from './AddonDetailResponsiveContent'

type TProps = NoChildren & {
  branchId: PropsOf<typeof AddonDetailStateProvider>['branchId']
}

/**
 * Screen-like component for MAIN addon detail rendering.
 * Renders contexts (containing logic) and responsive content component (visuals).
 */
export const AddonDetail: React.FC<TProps> = ({ branchId }) => {
  return (
    <AddonDetailStateProvider branchId={branchId}>
      <AddonDetailResponsiveContent />
    </AddonDetailStateProvider>
  )
}
